import { render, staticRenderFns } from "./Nmpa.vue?vue&type=template&id=6717ca15&scoped=true"
import script from "./Nmpa.vue?vue&type=script&lang=js"
export * from "./Nmpa.vue?vue&type=script&lang=js"
import style0 from "./Nmpa.vue?vue&type=style&index=0&id=6717ca15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6717ca15",
  null
  
)

export default component.exports